export default __webpack_public_path__ + "static/media/MacBook-Pro@2x.b07887b9.png";